// extracted by mini-css-extract-plugin
export default {"noResImg":"style_noResImg__+uvH1","noResText":"style_noResText__+QzRO","dark":"style_dark__zVtvn"};